var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDhl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 57,
    viewBox: "0 0 97 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 37.0821H12.89L12.2354 38.4055H1.5V37.0821Z",
    fill: "#D40511"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4916 38.4055L82.2117 37.0821H95.5V38.4055H81.4916Z",
    fill: "#D40511"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 34.6244H14.1992L13.4791 35.9478H1.5V34.6244Z",
    fill: "#D40511"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 32.1667H15.5084L14.7883 33.4901H1.5V32.1667Z",
    fill: "#D40511"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8008 35.9478L83.5209 34.6244H95.5V35.9478H82.8008Z",
    fill: "#D40511"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7646 32.1667H95.4345V33.4901H84.0446L84.7646 32.1667Z",
    fill: "#D40511"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8064 38.4055L19.8287 26.7786C19.8287 26.7786 26.5056 26.7786 27.2911 26.7786C28.1421 26.7786 28.1421 27.2512 27.6838 28.0075C27.2911 28.7637 26.571 30.1816 26.1783 30.9378C25.9819 31.4104 25.5891 32.0721 26.8329 32.0721C28.2075 32.0721 36.8482 32.0721 36.8482 32.0721C36.0627 33.7736 33.3134 38.5 28.4694 38.5C24.5418 38.4055 13.8064 38.4055 13.8064 38.4055Z",
    fill: "#D40511"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3036 32.1667L45.0306 38.5H36.4554L39.7284 32.1667H48.3036Z",
    fill: "#D40511"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8064 32.1667L57.5334 38.5H48.8928L52.1657 32.1667H60.8064Z",
    fill: "#D40511"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6212 32.1667C63.6212 32.1667 62.9666 33.3955 62.7047 33.9627C61.5919 36.0423 62.5738 38.5 66.1086 38.5C70.1671 38.5 79.9861 38.5 79.9861 38.5L83.2591 32.1667H63.6212Z",
    fill: "#D40511"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0613 19.5945L15.0501 25.3607C15.0501 25.3607 30.5641 25.3607 31.415 25.3607C32.266 25.3607 32.266 25.8333 31.8078 26.5896C31.415 27.3458 30.695 28.7637 30.3022 29.5199C30.1058 29.898 29.7131 30.6542 30.9568 30.6542C32.3315 30.6542 37.6337 30.6542 37.6337 30.6542C37.6337 30.6542 38.7465 28.5746 39.5975 26.7786C40.8412 24.4154 39.7284 19.5 35.3426 19.5C31.415 19.5945 18.0613 19.5945 18.0613 19.5945Z",
    fill: "#D40511"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5265 30.6542H40.4485L46.2089 19.5945H54.8496L51.5766 25.9279H55.4387L58.7117 19.5945H67.3524L61.5265 30.6542Z",
    fill: "#D40511"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M79.266 19.5945L73.5056 30.6542H64.3412L70.1017 19.5945H79.266Z",
    fill: "#D40511"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDhl);
export default __webpack_public_path__ + "static/media/dhl.f37712e39c20d15d6b1f8f95f0664617.svg";
export { ForwardRef as ReactComponent };